import React, { useEffect, useState, Fragment } from "react"
import { useTable, useSortBy } from "react-table"
import { Table, Row, Col, Button, Container } from "reactstrap"
import Timevalue from "./timeValue"
const moment = require("moment")

const TimeLogTable = ({
  columns,
  data,
  widthControl,
  getSelectedRowwValues,
  accessGroup,
  setTableStatus,
  setClickedRow,
  setClickedRowToggle,
  isMobile,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    state: { pageIndex, pageSize },
  } = useTable({
    columns,
    data,
    initialState: {},
    useSortBy,
  })

  const [totalDuration, setTotalDuration] = useState("")
  const [activeDuration, setActiveDuration] = useState("")
  const [idleDuration, setIdleDuration] = useState("")
  const [evaluationDuration, setEvluationDuration] = useState("")
  const [tempIdHold, setTempIdHold] = useState(null)

  useEffect(() => {
    AddTotalDueration()
  }, [rows])

  const AddTotalDueration = () => {
    setTotalDuration(filter("TOTAL"))
    setIdleDuration(filter("IDLE"))
    setActiveDuration(filter("ACTIVE"))
    setEvluationDuration(filter("On Evaluation"))
  }

  const filter = key => {
    const filter = rows?.filter(el => el.values.activeStatusName === key)
    const TotalFilter = rows?.filter(
      el =>
        el.values.activeStatusName === "ACTIVE" ||
        el.values.activeStatusName === "IDLE"
    )
    return durationValue(key !== "TOTAL" ? filter : TotalFilter)
  }
  const durationValue = key => {
    const activeTotalDuration = key.map(time => {
      return time.values.duration
    })
    const activeTotal = activeTotalDuration?.reduce((total, duration) => {
      return total + moment.duration(duration).asSeconds()
    }, 0)
    return gettotalDuration(activeTotal)
  }

  const gettotalDuration = key => {
    const totalDurations = moment.utc(key * 1000).format("HH:mm:ss")
    return totalDurations
  }

  const generateSortingIndicator = column => {
    return column.isSorted ? (
      column.isSortedDesc ? (
        <i className="bx bx-sort-down"></i>
      ) : (
        <i className="bx bx-sort-up"></i>
      )
    ) : (
      ""
    )
  }

  const handleClickedRowToggle = id => {
    setTempIdHold(id)
    if (tempIdHold === id) {
      setClickedRowToggle(false)
      setTempIdHold(null)
    } else {
      setClickedRowToggle(true)
    }
  }

  return (
    <>
      <Timevalue
        activeDuration={activeDuration}
        idleDuration={idleDuration}
        evaluationDuration={evaluationDuration}
        totalDuration={totalDuration}
      />
      <Table {...getTableProps()} bordered responsive>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr
              key={headerGroup.id}
              {...headerGroup.getHeaderGroupProps()}
              className="table-light"
            >
              {headerGroup.headers.map(column => (
                <th
                  key={column.id}
                  onClick={() =>
                    accessGroup && onHeaderClick(column, pageSize, pageIndex)
                  }
                >
                  <div className={widthControl ? "mb-2 widthControl" : "mb-2"}>
                    {column.render("Header")}
                    {generateSortingIndicator(column)}
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {(rows?.length > 0 &&
            rows.map(row => {
              prepareRow(row)
              return (
                <Fragment key={row.getRowProps().key}>
                  <tr
                    className={row?.id == tempIdHold && "table-primary"}
                    style={{ cursor: "pointer" }}
                    {...row.getRowProps()}
                    onClick={e => {
                      {
                        ;(e.target.cellIndex || e.target.cellIndex === 0) &&
                          getSelectedRowwValues &&
                          getSelectedRowwValues(row)
                        setClickedRow(row)
                        handleClickedRowToggle(row.id)
                      }
                    }}
                  >
                    {row.cells.map(cell => {
                      setTableStatus(row, cell?.id)
                      return (
                        <td
                          key={cell.id}
                          {...cell.getCellProps()}
                          data-label={cell?.column?.Header}
                        >
                          {cell.render("Cell")}
                        </td>
                      )
                    })}
                  </tr>
                </Fragment>
              )
            })) || (
            <tr>
              {!isMobile ? (
                <td
                  colSpan={"11"}
                  className="react-bs-table-no-data text-center"
                >
                  Sorry, There are no data to display
                </td>
              ) : (
                <div className="table-info text-center">
                  <span>Sorry, There are no data to display</span>
                </div>
              )}
            </tr>
          )}
          {isMobile == false ? (
            <>
              {rows?.length != 0 && (
                <tr className="table-info">
                  <td colSpan={3} className="text-right font-weight-bold">
                    Total
                  </td>
                  <td
                    colSpan={6}
                    className="text-left"
                    style={{ color: "red" }}
                  >
                    {totalDuration}
                  </td>
                </tr>
              )}
            </>
          ) : (
            <>
              {rows?.length != 0 && (
                <div className="table-info " style={{ marginTop: "-14px" }}>
                  <div className="d-flex justify-content-center">
                    <span
                      className="text-right font-weight-bold"
                      style={{ whiteSpace: "pre" }}
                    >
                      Total: {"   "}
                    </span>
                    <span style={{ color: "red" }}>{totalDuration}</span>
                  </div>
                </div>
              )}
            </>
          )}
        </tbody>
      </Table>
    </>
  )
}

export default TimeLogTable
